import { Minus, Plus } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useLang } from "@/lib/i18n";

export const Stepper = ({ value, min = 0, max = 10, onChange, label, testid, size = "md" }) => {
  const btn = size === "sm" ? "h-8 w-8" : "h-9 w-9";
  return (
    <div className="inline-flex items-center gap-3" data-testid={testid}>
      <button
        type="button"
        aria-label={`${label} –`}
        data-testid={`${testid}-decrement`}
        onClick={() => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        className={`inline-flex ${btn} items-center justify-center rounded-full border border-foreground/40 text-foreground transition-colors hover:border-foreground disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:border-foreground/40`}
      >
        <Minus className="h-4 w-4" />
      </button>
      <span className="w-5 text-center text-base font-medium tabular text-foreground" data-testid={`${testid}-value`}>{value}</span>
      <button
        type="button"
        aria-label={`${label} +`}
        data-testid={`${testid}-increment`}
        onClick={() => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
        className={`inline-flex ${btn} items-center justify-center rounded-full border border-foreground/40 text-foreground transition-colors hover:border-foreground disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:border-foreground/40`}
      >
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
};

const Row = ({ title, sub, control }) => (
  <div className="flex items-center justify-between gap-6 py-4">
    <div>
      <p className="text-base font-medium text-foreground">{title}</p>
      <p className="text-sm text-muted-foreground">{sub}</p>
    </div>
    {control}
  </div>
);

/** Party picker: adults, children, dog. Stacked rows with hairlines. */
export const GuestPicker = ({ adults, children, dog, onChange, testid = "guest-picker" }) => {
  const { tx } = useLang();
  return (
    <div className="divide-y divide-border" data-testid={testid}>
      <Row title={tx("Vaksne", "Adults")} sub={tx("13 år og eldre", "Age 13+")}
        control={<Stepper label={tx("Vaksne", "Adults")} value={adults} min={1} max={16} onChange={(v) => onChange({ adults: v })} testid={`${testid}-adults`} />} />
      <Row title={tx("Born", "Children")} sub={tx("0–12 år", "Age 0–12")}
        control={<Stepper label={tx("Born", "Children")} value={children} min={0} max={10} onChange={(v) => onChange({ children: v })} testid={`${testid}-children`} />} />
      <Row title={tx("Hund", "Dog")} sub={tx("Velkomen på Elvafløy", "Welcome in the River Wing")}
        control={<Switch checked={dog} onCheckedChange={(v) => onChange({ dog: v })} data-testid={`${testid}-dog-toggle`} aria-label={tx("Hund", "Dog")} />} />
    </div>
  );
};
